import { render, staticRenderFns } from "./explainer-text-message.vue?vue&type=template&id=bc316414&scoped=true&"
import script from "./explainer-text-message.vue?vue&type=script&lang=js&"
export * from "./explainer-text-message.vue?vue&type=script&lang=js&"
import style0 from "./explainer-text-message.vue?vue&type=style&index=0&id=bc316414&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc316414",
  null
  
)

export default component.exports